import { useEffect } from 'react';
import { SettingsService } from '../services/settingsService';

export const useBranding = () => {
  useEffect(() => {
    const loadAndApplyBranding = async () => {
      try {
        const settings = await SettingsService.getSettings();

        // Apply color variables to document root
        const root = document.documentElement;

        // Header/Navigation
        root.style.setProperty('--header-background', settings.colors.headerBackground);
        root.style.setProperty('--header-text', settings.colors.headerText);
        root.style.setProperty('--header-button', settings.colors.headerButton);

        // Main Content
        root.style.setProperty('--main-background', settings.colors.mainBackground);
        root.style.setProperty('--main-text', settings.colors.mainText);
        root.style.setProperty('--secondary-text', settings.colors.secondaryText);

        // Buttons
        root.style.setProperty('--primary-button', settings.colors.primaryButton);
        root.style.setProperty('--primary-button-text', settings.colors.primaryButtonText);
        root.style.setProperty('--secondary-button', settings.colors.secondaryButton);
        root.style.setProperty('--secondary-button-text', settings.colors.secondaryButtonText);

        // UI Elements
        root.style.setProperty('--border-color', settings.colors.border);
        root.style.setProperty('--accent-color', settings.colors.accent);

        // Status Colors
        root.style.setProperty('--success-color', settings.colors.success);
        root.style.setProperty('--warning-color', settings.colors.warning);
        root.style.setProperty('--error-color', settings.colors.error);

        // Set typography variables
        root.style.setProperty('--font-family', settings.typography.fontFamily);
        root.style.setProperty('--font-size-h1', `${settings.typography.fontScale.h1}px`);
        root.style.setProperty('--font-size-h2', `${settings.typography.fontScale.h2}px`);
        root.style.setProperty('--font-size-h3', `${settings.typography.fontScale.h3}px`);
        root.style.setProperty('--font-size-body', `${settings.typography.fontScale.body}px`);

        // Update page title if company name is set
        if (settings.branding.companyName) {
          document.title = settings.branding.companyName + ' - Quoting System';
        }

        console.log('Branding settings applied');
      } catch (error) {
        console.error('Failed to load branding settings:', error);
      }
    };

    loadAndApplyBranding();
  }, []);
};
